import React from 'react';

import { useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';

import { useStyles } from './AlertScreenResolutionUseStyles';

export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

const AlertScreenResolution = () => {
  const [windowDimensions, setWindowDimensions] = React.useState(
    getWindowDimensions()
  );

  const classes = useStyles();

  const useString = () => {
    const lang = useSelector(state => state.language);
    return lang.alerts.screenResolution;
  };

  const subtitles = useString();

  React.useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      {(windowDimensions.width < 1024 || windowDimensions.height < 720) && (
        <div className={classes.AlertScreen}>
          <Typography className={`${classes.AlertScreen}__text`}>
            {subtitles.desc1_}
            <strong>
              {windowDimensions.width}
              &nbsp;x&nbsp;{windowDimensions.height}
            </strong>
            &nbsp;
            {subtitles.desc2_}
            <strong>1024</strong>&nbsp;{subtitles.desc3_}
            <strong>720</strong>&nbsp;{subtitles.desc4_}
          </Typography>
        </div>
      )}
    </>
  );
};
export default AlertScreenResolution;
